import { ROUTER_CONSTANT } from "../constants/routerConstant"

export const getContent = response => {
    if (response.data.nexsoft.payload.data.content === null) {
        return []
    }
    return response.data.nexsoft.payload.data.content
}

export const getErrorCode = error => {
    return error.response.data.nexsoft.payload.status.code
}

export const getErrorMessage = error => {
    return error.response.data.nexsoft.payload.status.message
}

export const getAditional = response => {
    return response.data.nexsoft.payload.data.aditional_information
}

export const getServerTime = response => {
    return response.data.nexsoft.header.timestamp
}

export const errorHandler = (dispatch, history, customErrorHandler) => {
    return err => {
        if (err.response?.status === 401) {
            dispatch()
            history.push(ROUTER_CONSTANT.LOGIN)
            return
        }
        if (err.response?.status === 403) {
            history.push(ROUTER_CONSTANT.FORBIDDEN)
            return
        }
        if (customErrorHandler) {
            customErrorHandler(err)
        }
    }
}